import { createSlice } from "@reduxjs/toolkit";
import { addDistrict, editDistrict, getDistrict, getDistrictList } from "../services/district-services";


const initialState = {
  districts: [],
  district: null,
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const districtSlice = createSlice({
  name: "district",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDistrictList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getDistrictList.fulfilled, (state, action) => {
        state.districts = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getDistrictList.rejected, (state, action) => {
        state.loading = false; 
      })
      .addCase(getDistrict.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getDistrict.fulfilled, (state, action) => {
        state.districts = action.payload.data.item;
        state.pagination = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getDistrict.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addDistrict.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addDistrict.fulfilled, (state, action) => {
        state.districts = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(addDistrict.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(editDistrict.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editDistrict.fulfilled, (state, action) => {
        state.districts = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(editDistrict.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      
  },
});
export const { resetSuccess, resetState, resetError } = districtSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default districtSlice.reducer;
